"use client";

import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@clerk/nextjs";
import { useAuth as useAuthStore } from "@/stores/use-auth-store";

/**
 * Wrapper around useQuery that automatically waits for authentication to be ready
 * This prevents "Unauthorized" errors on page refresh by ensuring queries only run
 * when the auth token is available.
 */
export function useAuthenticatedQuery<TData = unknown, TError = unknown>(
  options: UseQueryOptions<TData, TError>
): UseQueryResult<TData, TError> {
  const { isLoaded } = useAuth();
  const token = useAuthStore((state) => state.token);

  // Automatically add auth check to enabled condition
  const enabled = options.enabled !== undefined 
    ? options.enabled && isLoaded && Boolean(token)
    : isLoaded && Boolean(token);

  return useQuery<TData, TError>({
    ...options,
    enabled,
  });
}

